<template>
  <div>
    <postcode-pop-comp
      :is-show.sync="isShowPostcodeModal"
      @returnResult="handleAddress"
    ></postcode-pop-comp>
    <modal v-if="isShow" class="search-friend-modal">
      <template slot="header">
        <h4 class="modal-title">장학금 신청서</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="closed"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <div class="paper-view">
          <div class="md-layout">
            <div class="md-layout-item no-padding">
              <h5><md-icon>trip_origin</md-icon>신청구분</h5>
              <p>
                {{ applyGbNm[modalData.applyGb] }}
              </p>
            </div>
            <div class="md-layout-item no-padding">
              <h5><md-icon>trip_origin</md-icon>교우자녀 확인</h5>
              <p>{{ childMemberInfo }}</p>
            </div>
          </div>

          <h5><md-icon>trip_origin</md-icon>신청인 정보</h5>
          <table class="flex-table">
            <tr>
              <th>캠퍼스 구분</th>
              <td>
                <input type="text" disabled v-model="modalData.collegeLCdNm" />
              </td>
              <th>단과대학</th>
              <td>
                <input type="text" disabled v-model="modalData.collegeMCdNm" />
              </td>
              <th>학과</th>
              <td>
                <input type="text" disabled v-model="modalData.collegeSCdNm" />
              </td>
              <th>학년</th>
              <td>
                <input
                  type="text"
                  disabled
                  v-model="modalData.collegeSemesterCdNm"
                />
              </td>
            </tr>
            <tr>
              <th>학번</th>
              <td><input type="text" v-model="modalData.hakbun" id="hakbun" name="hakbun" /></td>
              <th>이름</th>
              <td><input type="text" v-model="modalData.nm" id="nm" name="nm" /></td>
              <th>생년월일</th>
              <td><input type="text" v-model="modalData.bornYm" id="bornYm" name="bornYm" /></td>
              <th>성별</th>
              <td>
                <select v-model="modalData.sex" id="sex" name="sex" style="width:100%">
                  <option value="">성별</option>
                  <option value="M">남</option>
                  <option value="F">여</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>총 이수학기</th>
              <td>
                <select v-model="modalData.completeSemester" id="completeSemester" name="completeSemester">
                  <option value="">이수학기 선택</option>
                  <option v-for="n in 12" :key="n" :value="n">{{ n }}</option>
                </select>
              </td>
              <th>평균 성적</th>
              <td>
                <div class="inline-flex">
                  <input type="text" disabled :value="computedAvgHakjum" />
                  <span>/</span>
                  <input type="text" v-model="modalData.completeHakjum" />
                </div>
              </td>
              <th>전학기 성적</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-model="modalData.prevAvgHakjum"/>
                  <span>/</span>
                  <input type="text" v-model="modalData.prevComplateHakjum"/>
                </div>
              </td>
              <th>전전학기 성적</th>
              <td>
                <div class="inline-flex">
                  <input
                    type="text" v-model="modalData.prev2AvgHakjum" 
                  />
                  <span>/</span>
                  <input type="text" v-model="modalData.prev2ComplateHakjum"
                  />
                </div>
              </td>
            </tr>
          </table>

          <br />

          <h5><md-icon>trip_origin</md-icon>연락처</h5>
          <table class="flex-table">
            <tr>
              <th>본인</th>
              <td>
                <input type="text" v-model="modalData.phoneNo1" />
              </td>
              <th>긴급</th>
              <td>
                <input type="text" v-model="modalData.phoneNo2" />
              </td>
              <th>기타</th>
              <td>
                <input type="text" v-model="modalData.phoneNo3" />
              </td>
              <th>기타</th>
              <td>
                <input type="text" v-model="modalData.phoneNo4" />
              </td>
            </tr>
            <tr>
              <th>이메일</th>
              <td colspan="3">
                <input type="text" v-model="modalData.eMail" />
              </td>
              <th>이메일 2</th>
              <td colspan="3">
                <input type="text" v-model="modalData.eMail2" />
              </td>
            </tr>
            <tr>
              <th>부모 거주형태</th>
              <td>
                <select v-model="modalData.houseGb" name="houseGb" id="houseGb" style="width:120px">
                  <option value="">거주형태</option>
                  <option value="1">자가</option>
                  <option value="2">전세</option>
                  <!-- <option value="3">하숙</option>
                  <option value="4">자취</option>
                  <option value="5">기숙사</option> -->
                  <option value="3">월세</option>
                  <option value="9">기타</option>
                </select>
              </td>
              <th>기타</th>
              <td colspan="3">
                <input type="text" :readonly="modalData.houseGb !== '9'" v-model="modalData.houseEtc" />
              </td>
              <th>평수</th>
              <td>
                <input type="text" v-model="modalData.houseSize" />
              </td>
            </tr>
            <tr>
              <!--              <th>주소구분</th>-->
              <!--              <td>{{modalData.addressGbNm}}</td>-->
              <th>부모 주소</th>
              <td colspan="7">
                <div class="inline-flex" style="gap: 4px; align-items: center;">
                  <input type="text" style="width:90px;" placeholder="우편번호" v-model="modalData.address1" readonly />
                  <button @click="addressModalOpen('address')">
                    <md-icon>search</md-icon>
                  </button>
                  <input type="text" placeholder="기본주소" v-model="modalData.address2" readonly />
                  <input type="text" placeholder="상세주소" v-model="modalData.address3" />
                </div>
              </td>
            </tr>
            <tr>
              <th>재학생 거주형태</th>
              <td>
                <select v-model="modalData.sHouseGb" name="sHouseGb" id="sHouseGb" style="width:120px">
                  <option value="">거주형태</option>
                  <option value="1">자가</option>
                  <option value="2">전세</option>
                  <option value="3">하숙</option>
                  <option value="4">자취</option>
                  <option value="5">기숙사</option>
                  <option value="3">월세</option>
                  <option value="9">기타</option>
                </select>
              </td>
              <th>기타</th>
              <td colspan="3">
                <input type="text" :readonly="modalData.sHouseGb !== '9'" v-model="modalData.sHouseEtc" />
              </td>
            </tr>
             <tr>
              <th>재학생 주소</th>
              <td colspan="7">
                <div class="inline-flex" style="gap: 4px; align-items: center;">
                  <input type="text" style="width:90px;" placeholder="우편번호" v-model="modalData.sAddress1" readonly />
                  <button @click="addressModalOpen('studentAddress')">
                    <md-icon>search</md-icon>
                  </button>
                  <input type="text" placeholder="기본주소" v-model="modalData.sAddress2" readonly />
                  <input type="text" placeholder="상세주소" v-model="modalData.sAddress3" />
                </div>
              </td>
            </tr>
          </table>

          <br />

          <h5><md-icon>trip_origin</md-icon>가족사항</h5>
          <div class="family-add-form" style="margin-bottom:10px; width: 100%;">
            <select v-model="newFamily.relation" style="width:7%">
              <option value="">관계</option>
              <option value="부">부</option>
              <option value="모">모</option>
              <option value="형">형</option>
              <option value="제">제</option>
              <option value="자">자</option>
              <option value="매">매</option>
              <option value="기타">기타</option>
            </select>
            <input v-model="newFamily.nm" placeholder="성명" style="width:20%; margin: 2px; height: 100%;" maxlength="25" />
            <input v-model="newFamily.age" placeholder="연령" style="width:8%; margin: 2px;" maxlength="3" />
            <input v-model="newFamily.job" placeholder="직업, 직장-직위" style="width:30%; margin: 2px;" maxlength="50" />
            <input v-model="newFamily.income" placeholder="연소득(원)" style="width:25%; margin: 2px;" maxlength="10" />
            <button type="button" @click="addFamily" style="width: 5%;">추가</button>
          </div>
          <table class="flex-table">
            <colgroup>
              <col width="7%" />
              <col width="20%" />
              <col width="8%" />
              <col width="30%" />
              <col width="25%" />
              <col width="10%" />
            </colgroup>
            <thead>
              <tr>
                <th>관계</th>
                <th>성명</th>
                <th>연령</th>
                <th>직장</th>
                <th>연소득</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in familyList" :key="item.seqNo">
                <td><input type="text" style="text-align:center;" disabled :value="item.relation" /></td>
                <td><input type="text" style="text-align:center;" disabled :value="item.nm" /></td>
                <td><input type="text" style="text-align:center;" disabled :value="item.age" /></td>
                <td><input type="text" disabled :value="item.job" /></td>
                <td>
                  <input type="text" style="text-align: right;" disabled :value="item.income ? formatter.getCurrency(item.income) : ''" />
                  
                </td>
                <td>
                  <button type="button" @click="removeFamily(idx)">삭제</button>
                </td>
              </tr> 
            </tbody>
          </table>
          <br />

          <h5><md-icon>trip_origin</md-icon>장학 평가</h5>
          <table class="flex-table">
            <tr>
              <th class="letter-dense">소득구간 (분위)</th>
              <td>
                <!--modalData.natIncomeGradeCdNm-->
                <select v-model="modalData.natIncomeGradeCd">
                  <option value=""></option>
                  <option
                    v-for="item in GrdCdTypeList1"
                    :key="item.code"
                    :label="item.codeNm"
                    :value="item.code"
                  ></option>
                </select>
              </td>
              <th class="letter-dense">부모합산재산세</th>
              <td>
                <div class="inline-flex">
                  <select v-model="modalData.propertyTaxCd">
                    <option value=""></option>
                    <option
                      v-for="item in GrdCdTypeList2"
                      :key="item.code"
                      :label="item.codeNm"
                      :value="item.code"
                    ></option>
                  </select>
                </div>
              </td>
              <th class="letter-dense">부모합산연소득</th>
              <td>
                <div class="inline-flex">
                  <select v-model="modalData.propertyYearlyCd">
                    <option value=""></option>
                    <option
                      v-for="item in GrdCdTypeList3"
                      :key="item.code"
                      :label="item.codeNm"
                      :value="item.code"
                    ></option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <th class="letter-dense">부모상황선택</th>
              <td>
                <select v-model="modalData.parentConCd">
                  <option value=""></option>
                  <option
                    v-for="item in GrdCdTypeList4"
                    :key="item.code"
                    :label="item.codeNm"
                    :value="item.code"
                  ></option>
                </select>
              </td>
              <th class="letter-dense">본인외가족 대학생유무</th>
              <td>
                <select v-model="modalData.elseStudentYn">
                  <option value=""></option>
                  <option
                    v-for="item in GrdCdTypeList5"
                    :key="item.code"
                    :label="item.codeNm"
                    :value="item.code"
                  ></option>
                </select>
              </td>
              <th class="letter-dense">학업성적</th>
              <td>
                <div class="inline-flex">
                  <input type="text" disabled v-model="modalData.grade1CdNm" />
                  <input type="text" disabled v-model="modalData.grade2CdNm" />
                </div>
              </td>
            </tr>
            <tr>
              <th class="letter-dense">건강보험료구간</th>
              <td>
                <select v-model="modalData.healthInsuCd">
                  <option value=""></option>
                  <option
                    v-for="item in GrdCdTypeList8"
                    :key="item.code"
                    :label="item.codeNm"
                    :value="item.code"
                  ></option>
                </select>
              </td>
              <th class="letter-dense">아르바이트</th>
              <td>
                <select v-model="modalData.parttimeGb">
                  <option value=""></option>
                  <option
                    v-for="item in GrdCdTypeList9"
                    :key="item.code"
                    :label="item.codeNm"
                    :value="item.code"
                  ></option>
                </select>
              </td>
              <th class="letter-dense">교우회비납부</th>
              <td>
                <select v-model="modalData.memberDueCnt">
                  <option value=""></option>
                  <option
                    v-for="item in GrdCdTypeList10"
                    :key="item.code"
                    :label="item.codeNm"
                    :value="item.code"
                  ></option>
                </select>
              </td>
            </tr>
          </table>

          <br />

          <h5><md-icon>trip_origin</md-icon>장학금 수혜이력</h5>
          <table class="flex-table">
            <colgroup>
              <col width="10%" />
              <col width="10%" />
              <col width="45%" />
              <col width="35%" />
            </colgroup>
            <thead>
              <tr>
                <th>학년</th>
                <th>학기</th>
                <th>장학금 종류</th>
                <th>장학 금액</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in gotsList" v-bind:key="item.seqNo">
                <td>
                  <input
                    type="text"
                    style="text-align: center;"
                    disabled
                    :value="item.schYear"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    style="text-align: center;"
                    disabled
                    :value="item.schSemester"
                  />
                </td>
                <td>
                  <input type="text" disabled :value="item.schShipNm" />
                </td>
                <td>
                  <input
                    type="text"
                    style="text-align: right;"
                    disabled
                    :value="
                      item.amount ? formatter.getCurrency(item.amount) : ''
                    "
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <br />

          <h5><md-icon>trip_origin</md-icon>파일 첨부</h5>
          <p v-if="modalData.picDir">
            <a
              v-bind:href="
                downloadUrl +
                  '?orgFileName=신청서사진&fileFullPathName=' +
                  modalData.picDir
              "
              target="_blank"
              >신청서사진.jpg</a
            >
          </p>
          <p v-if="modalData.agreeDir">
            <a
              v-bind:href="
                downloadUrl +
                  '?orgFileName=부모동의서&fileFullPathName=' +
                  modalData.agreeDir
              "
              target="_blank"
              >부모동의서.jpg</a
            >
          </p>
          <p v-if="modalData.fileDir">
            <a
              v-bind:href="
                downloadUrl +
                  '?orgFileName=장학금신청서류&fileFullPathName=' +
                  modalData.fileDir
              "
              target="_blank"
              >장학금신청서류.zip</a
            >
          </p>
          <br />

          <h5><md-icon>trip_origin</md-icon>자기소개서</h5>
          <textarea
            v-model="modalData.selfIntroduction"
            rows="20"
            style="width:100%; height:300px; resize:vertical;line-height: 150%;white-space: pre-wrap; word-break: normal;"
            placeholder="자기소개서를 입력하세요."
          ></textarea>
        </div>
      </template>
      <template slot="footer">
        <md-button class="md-info md-sm" @click="goPrint"
          ><md-icon>get_app</md-icon>Pdf 다운로드</md-button
        >
        <md-button class="md-info md-sm" @click="admodify">수정</md-button>
        <md-button class="md-default md-sm" @click="closed">닫기</md-button>
      </template>
    </modal>
  </div>
  
</template>
<script>
import formatter from "@/kuaa/kuaa-formatter";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import { Modal } from "@/components";
import Swal from "sweetalert2";
import PostcodePopComp from "@/pages/Common/PostcodePopComp.vue";

export default {
  name: "ApplyDonorModalComp",

  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },

  components: {
    Modal,
    PostcodePopComp
  },

  created() {
    this.GrdCdTypes1();
    this.GrdCdTypes2();
    this.GrdCdTypes3();
    this.GrdCdTypes4();
    this.GrdCdTypes5();
    this.GrdCdTypes6();
    this.GrdCdTypes7();
    this.GrdCdTypes8();
    this.GrdCdTypes9();
    this.GrdCdTypes10();
  },

  computed: {
    computedAvgHakjum() {
      const a = parseFloat(this.modalData.prevAvgHakjum);
      const b = parseFloat(this.modalData.prev2AvgHakjum);
      if (!isNaN(a) && !isNaN(b)) {
        return (Math.round(((a + b) / 2) * 100) / 100).toFixed(2);
      }
      return '';
    }
  },

  data() {
    return {
      isPrintableApplicant: false,      
      isShowPostcodeModal: false,
      formatter,
      modalData: {},
      gotsList: [],
      familyList: [],
      applyGbNm: {
        "1": "개인명의",
        "2": "교우자녀",
        "3": "교우회(장학)"
      },

      addressGbNm: {
        "1": "자택(부모)",
        "2": "상경(지방)",
        "3": "독립(서울)"
      },

      childMemberInfo: "",
      //      printData: {},
      orgData: {},
      downloadUrl: URL_CONST.FILE_DOWN_LOAD_HP,
      familyList: [],
      newFamily: {
        relation: "",
        nm: "",
        age: "",
        job: "",
        income: ""
      }
    };
  },

  methods: {
    GrdCdTypes1() {
      kuaaFnc.fncListCmmCodeL("NTL_INC_GRD_CD", null, res => {
        this.GrdCdTypeList1 = res.data.data.contents;
      });
    },
    GrdCdTypes2() {
      kuaaFnc.fncListCmmCodeL("PROPERTY_TAX_CD", null, res => {
        this.GrdCdTypeList2 = res.data.data.contents;
      });
    },
    GrdCdTypes3() {
      kuaaFnc.fncListCmmCodeL("PRTY_YEAR_CD", null, res => {
        this.GrdCdTypeList3 = res.data.data.contents;
      });
    },
    GrdCdTypes4() {
      kuaaFnc.fncListCmmCodeL("PARENT_CON_CD", null, res => {
        this.GrdCdTypeList4 = res.data.data.contents;
      });
    },
    GrdCdTypes5() {
      kuaaFnc.fncListCmmCodeL("ELSE_STUDENT_YN", null, res => {
        this.GrdCdTypeList5 = res.data.data.contents;
      });
    },
    GrdCdTypes6() {
      kuaaFnc.fncListCmmCodeL("GRADE1_CD", null, res => {
        this.GrdCdTypeList6 = res.data.data.contents;
      });
    },
    GrdCdTypes7() {
      kuaaFnc.fncListCmmCodeL("GRADE2_CD", null, res => {
        this.GrdCdTypeList7 = res.data.data.contents;
      });
    },
    GrdCdTypes8() {
      kuaaFnc.fncListCmmCodeL("HEALTH_INSU_CD", null, res => {
        this.GrdCdTypeList8 = res.data.data.contents;
      });
    },
    GrdCdTypes9() {
      kuaaFnc.fncListCmmCodeL("PARTTIME_CD", null, res => {
        this.GrdCdTypeList9 = res.data.data.contents;
      });
    },
    GrdCdTypes10() {
      kuaaFnc.fncListCmmCodeL("MEMBER_DUE_CNT", null, res => {
        this.GrdCdTypeList10 = res.data.data.contents;
      });
    },

    handleAddress: function(data) {
      let zonecode = data.zonecode; // 우편번호
      let fullAddress = data.address; // 기본주소
      let extraAddress = "";

      if (data.addressType === "R") {
        if (data.bname !== "") extraAddress += data.bname;
        if (data.buildingName !== "") {
          extraAddress += extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName;
        }
        fullAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
      }

      // selectedAddressType에 따라 다른 필드에 할당
      if (this.selectedAddressType === 'studentAddress') {
        // 재학생 주소
        this.modalData.sAddress1 = zonecode;
        this.modalData.sAddress2 = fullAddress;
        this.modalData.sAddress3 = ""; // 상세주소는 사용자가 직접 입력
      } else {
        // 부모 주소
        this.modalData.address1 = zonecode;
        this.modalData.address2 = fullAddress;
        this.modalData.address3 = ""; // 상세주소는 사용자가 직접 입력
      }

      this.isShowPostcodeModal = false;
    },
    addressModalOpen: function(addressType, event) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      this.isShowPostcodeModal = true;
      this.selectedAddressType = addressType;
    },

    closed() {
      this.$emit("update:isShow", false);
    },

    setData(item) {
      console.log("setData", item);
      this.orgData = item;
      this.modalData = item;
      this.printData = item;

      //교우자녀
      if (item["applyGb"] == "2") {
        //} || item['parentMemberHnm']) {
        //this.childMemberInfo = item['parentMemberHnm'] + ' (' + (item['parentCollegeCdNm'] ? item['parentCollegeCdNm'] : '') + ' / ' + (item['parentHakbun'] ? item['parentHakbun'] : '') + ')';
        this.childMemberInfo =
          item["parentMemberHnm"] +
          " (" +
          (item["parentClassCdNm"] ? item["parentClassCdNm"] : "") +
          " / " +
          (item["parentHakbun"] ? item["parentHakbun"] : "") +
          ")";
      } else {
        this.childMemberInfo = "";
      }
      // this.getMemberByNo();
      this.getGotsListByNo();
      this.getFamilyListByNo();

      this.printData["familyList"] = this.familyList;
      this.printData["gotsList"] = this.gotsList;
      this.printData["applyGbNm"] = this.applyGbNm[this.modalData.applyGb];
      this.printData["addressGbNm"] = this.addressGbNm[
        this.modalData.addressGb
      ];
      this.printData["childMemberInfo"] = this.childMemberInfo;
    },

    // 장학금 수혜이력 조회
    getGotsListByNo() {
      if (this.modalData.applySeqNo) {
        let modalOptions = kuaaFnc.getSwalModaloptions();
        kuaaApi.sendServer(
          URL_CONST.GET_SCHA_APPLY_GOTS_LIST,
          { applySeqNo: this.modalData.applySeqNo },
          "post",
          response => {
            if (response.data.result) {
              this.gotsList = response.data.data.contents;
              this.printData["gotsList"] = this.gotsList;
            } else {
              modalOptions.html = `조회 실패 하였습니다.`;
              Swal.fire(modalOptions);
            }
          }
        );
      }
    },
    getFamilyListByNo() {
      if (this.modalData.applySeqNo) {
        let modalOptions = kuaaFnc.getSwalModaloptions();
        kuaaApi.sendServer(
          URL_CONST.GET_SCHA_APPLY_FAMILY_LIST,
          { applySeqNo: this.modalData.applySeqNo },
          "post",
          response => {
            if (response.data.result) {
              this.familyList = response.data.data.contents;
              this.printData["familyList"] = this.familyList;
            } else {
              modalOptions.html = `조회 실패 하였습니다.`;
              Swal.fire(modalOptions);
            }
          }
        );
      }
    },
    goPrint() {
      this.$emit("returnResult", this.printData);
    },
  addFamily() {
  if (!this.newFamily.relation || !this.newFamily.nm || !this.newFamily.age || !this.newFamily.job || !this.newFamily.income) {
    alert("모든 항목을 입력해 주세요.");
    return;
  }
  // seqNo: 기존 리스트의 최대값 + 1
  let maxSeqNo = this.familyList.length > 0
    ? Math.max(...this.familyList.map(f => Number(f.seqNo) || 0))
    : 0;
  const seqNo = maxSeqNo + 1;
  this.familyList.push({
    ...this.newFamily,
    seqNo: seqNo,
    applySeqNo: this.modalData.applySeqNo,
    useYn: "Y"
  });
  this.newFamily = { relation: "", nm: "", age: "", job: "", income: "" };
},
  removeFamily(idx) {
    this.familyList.splice(idx, 1);
  },
    admodify() {
      if (window.confirm('수정 하시겠습니까?')) {
        let params = JSON.parse(JSON.stringify(this.modalData));
        params.familyList = this.familyList;
        kuaaApi.sendServer(
          URL_CONST.UPDATE_SCHA_APPLY,
          params,
          "post",
          response => {
            if (response.data.success) {
              alert('장학금 신청서가 성공적으로 수정되었습니다.');
              this.closed();
              this.$nextTick(() => {
                this.$emit('updateList');
              });
            } else {
              alert(response.data.message || '서버 오류가 발생했습니다.');
            }
          }
        );
      }
    }
  }
};
</script>


<style lang="css">
/* SweetAlert2 z-index fix - container와 popup 모두 적용 */
.swal2-container,
.swal2-zindex-fix {
  z-index: 9999 !important;
}
</style>
